import { render, staticRenderFns } from "./moveUpImg.vue?vue&type=template&id=0af36d4f&"
import script from "./moveUpImg.vue?vue&type=script&lang=js&"
export * from "./moveUpImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports